module.exports = {
	title:'账号',
	levelholder:'请选择账号级别',
	level:{
		yes:'超级管理员',
		no:'非超级管理员',
	},
	searchholder:'请输入账号名称搜索',
	add:'添加用户',
	loginname:'登录名',
	phone:'手机号码',
	portrait:'头像',
	nickname:'昵称',
	lastlogin:'最后登录时间',
	manager:'超级管理员',
	lock:'锁定',
	role:'角色',
	name:'账号名',
	phone1:'账号手机',
	password:'密码',
	nameholder:'请输入账号名',
	phoneholder:'请输入账号手机',
	nickholder:'请输入昵称',
	wordholder:'若不修改密码，则无需输入',
	setrole:'配置角色',
	namemsg:'账号名称不能为空',
	phonemsg:'手机号码不能为空',
	phonemsg1:'手机格式错误',
	nickmsg:'昵称不能为空',
	code:'二维码',
	downloadcode:'点击下载二维码',
	binduser:'已绑定用户',
	seebind:'点击查看已绑定用户',
	bindtitle:'已绑定成员'
	
}


// WEBPACK FOOTER //
// ./src/i18n/locales/en-us/modules/user.js